(function () {
  var KEYS = ['fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SK = 'msd_tp';

  function stored() {
    try { return JSON.parse(sessionStorage.getItem(SK) || 'null'); } catch (e) { return null; }
  }

  // Capture from URL immediately — sessionStorage write is synchronous
  (function () {
    var p = new URLSearchParams(window.location.search);
    var found = {};
    KEYS.forEach(function (k) { if (p.has(k)) found[k] = p.get(k); });
    if (Object.keys(found).length) {
      try { sessionStorage.setItem(SK, JSON.stringify(found)); } catch (e) {}
    }
  })();

  function patchLinks() {
    var params = stored();
    if (!params) return;
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        var changed = false;
        Object.keys(params).forEach(function (k) {
          if (!url.searchParams.has(k)) { url.searchParams.set(k, params[k]); changed = true; }
        });
        if (changed) a.href = url.pathname + url.search + (url.hash || '');
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchLinks();
    // Watch for product cards injected by <product-recommendations> async fetch
    if (window.MutationObserver) {
      var obs = new MutationObserver(patchLinks);
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    }
  });
})();
